<!-- 予約登録枠数マスタ　一括登録画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<style scoped>
	/* 編集していないレコード */
	.calmListNoEdit {}
	/* 編集中のレコード */
	#mainAC #wcalm .calendar .calmListEdit dl {
		background-color: plum;
	} 

</style>
<template>
	<section class="contents" id="wcalm">
		<!-- ▽ -->
		<section id="mainContent">
			<h2>休業日マスタ</h2>
			<ul class="contntMenu">
				<li class="onReserve" v-on:click="onBulkReserve">期間指定一括登録</li>
				<li class="onBack" v-on:click="onBack">TOP</li>
			</ul>

			<!-- ▽  -->
			<section class="inputArea">

				<!-- 表示月選択 -->
				<div class="caption">
					<div class="listUp">
						<ul class="dayForm ym">
							<li>
							<select v-model="inputForm.year">
								<option value=0>選択</option>
								<option v-for="item in inputForm.listYear" v-bind:key="item">
									{{item}}
								</option>
							</select><!-- 年 -->
										</li>
							<li>
							<select v-model="inputForm.month">
								<option value=0>選択</option>
								<option v-for="item in inputForm.listMonth" v-bind:key="item">
									{{item}}
								</option>
							</select><!-- 月 -->
							</li>
						</ul>
						<button class="confBtn" v-on:click="onChangeCalender">表示</button>
					</div>
					<div class="btnLst">
						<button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>
					</div>
				</div>

				<!-- 休業日マスタの表示 -->
				<section class="calendar">
					<ul class="calendarHeader"><li>日</li><li>月</li><li>火</li><li>水</li><li>木</li><li>金</li><li>土</li></ul>

					<div v-for="(item,index) in calmList" v-bind:key="item.date" v-bind:class="[getClassNameByRecordStatuses(index),getClassNameByDay(index)]">
						<dl>
	<!--				<dt v-bind:class="getClassNameByDay(index)">{{getStrDate(item.date,item.day)}}</dt>-->
							<dt>{{getStrDate(item.date,item.day)}}</dt>
							<dd>
								<ul>
									<li><label v-bind:for="getBindId('calmOpen',index)"><input type="radio" v-bind:id="getBindId('calmOpen',index)" v-bind:value="codeCkbnOpen" v-model="item.ckbn" v-on:change="changeRecord(index)"><span>営業日</span></label></li>
									<li><label v-bind:for="getBindId('calmClose',index)"><input type="radio" v-bind:id="getBindId('calmClose',index)" v-bind:value="codeCkbnClose" v-model="item.ckbn" v-on:change="changeRecord(index)"><span>休業日</span></label></li>
								</ul>
							</dd>
						</dl>
					</div>
				</section>

			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onUpdate">OK</button></li>
					<li><button v-on:click="onConfirmUpdateModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</section >
</template>
<script>
	import { WCALMApi } from '@/api'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWCALM',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		data() {
			return {
				// 入力フォーム
				inputForm: {

					// 年のプルダウン内容
					listYear:[],

					// 年
					year: 0,

					// 月のプルダウン内容
					listMonth: [
						1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
					],

					// 月
					month: 0,
				},

				// カレンダー表示用
				calender: {
					year: 0,
					month: 0
				},

				// 休業日マスタ
				// date:  日付（YYYY/MM/DD）
				// ckbn:  休業区分（1:休業日 9:営業日）
				calmList: [],
				// 9:営業日
				codeCkbnOpen: '9',
				// 1:休業日
				codeCkbnClose: '1',

				// 休業日マスタの最小日付と最大日付
				calmData: {
					// 最小日付　年
					minDateYear: 0,
					// 最小日付　月
					minDateMonth: 0,
					// 最小日付　日付
					minDateDate: 0,
					// 最大日付　年
					maxDateYear: 0,
					// 最大日付　月
					maxDateMonth: 0,
					// 最大日付　日付
					maxDateDate: 0
				},

				// 現在時刻
				currentDateTime: {
					// 年
					YYYY: 0,
					// 月
					MM: 0,
					// 日
					DD: 0,
					// 時間
					hh: 0,
					// 分
					mm: 0
				},
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmUpdate: {
						messages: [
							'更新しますか？'
						],
						isShow: false
					},
				}
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWCALM::created Start')

			this.firstDisplay();

			UtilityConsoleLog.consoleLog('MasterWCALM::created End')
		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog('MasterWCALM::firstDisplay Start')

				// 非同期通信
				WCALMApi.FirstDisplay({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 年のプルダウン内容
						this.inputForm.listYear = responce.data.listYear

						// 休業日マスタ
						this.calmList = responce.data.calmList
	
						// 休業日マスタの最小日付と最大日付
						this.calmData.minDateYear = responce.data.calmData.minDateYear
						this.calmData.minDateMonth = responce.data.calmData.minDateMonth
						this.calmData.minDateDate = responce.data.calmData.minDateDate
						this.calmData.maxDateYear = responce.data.calmData.maxDateYear
						this.calmData.maxDateMonth = responce.data.calmData.maxDateMonth
						this.calmData.maxDateDate = responce.data.calmData.maxDateDate
	
						// 現在時刻
						this.currentDateTime.YYYY = responce.data.currentDateTime.YYYY
						this.currentDateTime.MM = responce.data.currentDateTime.MM
						this.currentDateTime.DD = responce.data.currentDateTime.DD
						this.currentDateTime.hh = responce.data.currentDateTime.hh
						this.currentDateTime.mm = responce.data.currentDateTime.mm

						// 現在のカレンダー表示
						this.calender.year = responce.data.currentDateTime.YYYY
						this.inputForm.year = this.calender.year
						this.calender.month = responce.data.currentDateTime.MM
						this.inputForm.month = this.calender.month

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
							
							// エラーメッセージ
							var tempErrorMessages = [
								responce.data.errorMessage
							]
							// 入力エラーダイアログを流用する
							this.onValidationErrorModalOpen(tempErrorMessages)

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWCALM::firstDisplay End')
				})
			},
			// カレンダー表示月変更
			onChangeCalender: function () {
				UtilityConsoleLog.consoleLog('MasterWCALM::onChangeCalender Start')

				this.calender.year = this.inputForm.year
				this.calender.month = this.inputForm.month

				// 非同期通信
				WCALMApi.ChangeCalender({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					calenderYear: this.calender.year,
					calenderMonth: this.calender.month
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

							// レスポンスの受け取り

							// 休業日マスタ
							this.calmList = responce.data.calmList

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM){
							// 入力エラーダイアログを流用する
							this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
							// システム、DBエラー時
							this.onSystemErrorModalOpen()
					}

				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWCALM::onChangeCalender End')
				})
			},
			// 更新
			onUpdate: function() {
				UtilityConsoleLog.consoleLog('MasterWCALM::onUpdate Start')

				// 更新用データの作成
				var tempUpdateData = this.createUpdateData()

				// 非同期通信
				WCALMApi.Update({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					calenderYear: this.calender.year,
					calenderMonth: this.calender.month,
					dates: tempUpdateData.dates,
					ckbns: tempUpdateData.ckbns,
					recordStatuses: tempUpdateData.recordStatuses
				}).then(({ responce }) => {

					// 更新確認モーダルを閉じる
					this.onConfirmUpdateModalClose()

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 休業日マスタ
						this.calmList = responce.data.calmList

						// 休業日マスタの最小日付と最大日付
						this.calmData.minDateYear = responce.data.calmData.minDateYear
						this.calmData.minDateMonth = responce.data.calmData.minDateMonth
						this.calmData.minDateDate = responce.data.calmData.minDateDate
						this.calmData.maxDateYear = responce.data.calmData.maxDateYear
						this.calmData.maxDateMonth = responce.data.calmData.maxDateMonth
						this.calmData.maxDateDate = responce.data.calmData.maxDateDate

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWCALM::onUpdate End')
				})
			},
			// 更新用データの作成
			createUpdateData: function() {
			
				var resultDates = []
				var resultCkbns = []
				var resultRecordStatuses = []
				
				for(var i=0;i<this.calmList.length;i++){
				
					// 前月、次月は空文）
					resultDates.push(this.calmList[i].date)
					resultCkbns.push(this.calmList[i].ckbn)
					resultRecordStatuses.push(this.calmList[i].recordStatus)
				}

				var resultObject = {
					dates: resultDates,
					ckbns: resultCkbns,
					recordStatuses: resultRecordStatuses,
				}
			
				return resultObject
			},
			// レコードに変更があったとき
			changeRecord: function(index) {
			
				if('0' == this.calmList[index].recordStatus){
					this.calmList[index].recordStatus = '12'
				} else if('1' == this.calmList[index].recordStatus) {
					this.calmList[index].recordStatus = '13'
				}
			},
			// recordStatusによってクラスを設定する
			getClassNameByRecordStatuses: function(index) {
			
				var resultClassName = ''

				if('12' == this.calmList[index].recordStatus
					|| '13' == this.calmList[index].recordStatus){
					resultClassName = 'calmListEdit'
				} else {
					resultClassName = 'calmListNoEdit'
				}
			
				return resultClassName
			},
			getClassNameByDay: function(index) {

				var resultClassName = ''

				switch(this.calmList[index].day){
					case '1':
						resultClassName = 'calmListDaySun'
						break
					case '2':
						resultClassName = 'calmListDayMon'
						break
					case '3':
						resultClassName = 'calmListDayTue'
						break
					case '4':
						resultClassName = 'calmListDayWed'
						break
					case '5':
						resultClassName = 'calmListDayThu'
						break
					case '6':
						resultClassName = 'calmListDayFri'
						break
					case '7':
						resultClassName = 'calmListDaySat'
						break
					default:
						//resultClassName = 'calmListDayOther'
						break
				}

				return resultClassName
			},
			// 期間一括登録画面
			onBulkReserve: function () {
				UtilityConsoleLog.consoleLog("MasterWCALM::onBulkReserve Start")

				this.$router.push("/MasterWCALMBulk")

				UtilityConsoleLog.consoleLog("MasterWCALM::onBulkReserve End")
			},
			// ラジオ用 for、idに名前割り当て
			getBindId: function(in_for,in_index) {
				return in_for + String(in_index)
			},
			// ラジオ用 nameに名前割り当て
			getBindName: function(in_name,in_index) {
				return in_name + String(in_index)
			},
			// メニューへ戻る
			onBack: function () {
				UtilityConsoleLog.consoleLog("MasterWCALM::onBack Start")

				this.$router.push("/AdminReserveStatusCheck")

				UtilityConsoleLog.consoleLog("MasterWCALM::onBack End")
			},
			// 文字列の日付をYYYY年MM月DD日(曜日)に整形
			getStrDate: function(in_date,in_day){

				// Date型に変換
				var tempDate = new Date(in_date)
				
				// 年月日を取得
				var tempStrYear = tempDate.getFullYear()
				var tempStrMonth = (' ' + (tempDate.getMonth() + 1)).slice(-2)
				var tempStrDate = (' ' + tempDate.getDate()).slice(-2)

				var tempStrDay = ' '

				switch(in_day) {
					case '1':
					 tempStrDay = '日'  
					 break
					case '2':
					 tempStrDay = '月'
					 break
					case '3':
					 tempStrDay = '火'
					 break
					case '4':
					 tempStrDay = '水'
					 break
					case '5':
					 tempStrDay = '木'
					 break
					case '6':
					 tempStrDay = '金'
					 break
					case '7':
					 tempStrDay = '土'
					 break
					default:
						break
				}

				return tempStrYear + '/'
					+ tempStrMonth + '/'
					+ tempStrDate + ' '
					+ '(' + tempStrDay + ')'

			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWCALM::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWCALM::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWCALM::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWCALM::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWCALM::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWCALM::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWCALM::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWCALM::onSystemErrorModalClose End')
			},
			// 更新確認モーダルを開く
			onConfirmUpdateModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWCALM::onConfirmUpdateModalOpen Start')

				this.modalOpen('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWCALM::onConfirmUpdateModalOpen End')
			},
			// 更新確認モーダルを閉じる
			onConfirmUpdateModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWCALM::onConfirmUpdateModalClose Start')

				this.modalClose('confirmUpdate')

				UtilityConsoleLog.consoleLog('MasterWCALM::onConfirmUpdateModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWCALM::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWCALM::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWCALM::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWCALM::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
      }
		}
	}

</script>


// WEBPACK FOOTER //
// src/components/Admin/Master/WCALM/MasterWCALM.vue